'use client';

import { ChevronLeft } from 'lucide-react';
import Skeleton from '~/components/Loading/Skeleton';
import PendingLink from '~/components/Navigation/PendingLink';
import { SettingsNav } from '~/components/settings/SettingsNav';
import { useSettingsNavItems } from '~/components/settings/useSettingsNavItems';

function SettingsNavSkeleton() {
  return (
    <div className="flex flex-col gap-0.5" aria-busy="true">
      {Array.from({ length: 7 }).map((_, i) => (
        <Skeleton key={i} className="h-9 w-full rounded-md" />
      ))}
    </div>
  );
}

export function SettingsAppNav() {
  const { items, isLoading, workspaceId } = useSettingsNavItems();
  const backHref = workspaceId ? `/${workspaceId}` : '/';

  return (
    <div className="bg-sidebar text-sidebar-foreground hidden h-full w-52 shrink-0 flex-col overflow-x-hidden overflow-y-auto px-2 py-3 md:flex">
      <PendingLink
        href={backHref}
        className="text-muted-foreground hover:bg-sidebar-accent/60 hover:text-foreground mb-1 inline-flex w-full items-center gap-1.5 rounded-md px-2 py-2 text-sm no-underline outline-none transition-colors focus-visible:ring-[3px] focus-visible:ring-ring/50"
      >
        <ChevronLeft className="size-4 shrink-0" />
        <span className="truncate">Back to app</span>
      </PendingLink>

      <div className="border-sidebar-border my-2 border-t" />

      {isLoading ? <SettingsNavSkeleton /> : <SettingsNav items={items} />}
    </div>
  );
}
